import { render } from "./TheZoneList.vue?vue&type=template&id=a0b25dde"
import script from "./TheZoneList.vue?vue&type=script&lang=js"
export * from "./TheZoneList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__